
define('unknown/views/actView',[
	'jquery',
	'underscore',
	'backbone',
	'unknown/models/activationModel',
], function($, _, Backbone, ActivationModel){
	var ActFooterView = Backbone.View.extend({
		events: {
			'click #actFormSubmit': 'submitForm'
		},
		
		initialize: function(options) {
			this.event = options.event;
			
			this.showForm();
			
			this.listenTo(this.event, 'default', this.showForm);
			this.listenTo(this.event, 'saving', this.showNonForm);
			this.listenTo(this.event, 'errorPrevAct', this.showNonForm);
			this.listenTo(this.event, 'error', this.showForm);
			this.listenTo(this.event, 'success', this.showNonForm);
		},
		
		submitForm: function () {
			this.event.trigger("save");
		},
		
		showForm: function () {
			this.$("#actFormSubmit").show();
		},
		
		showNonForm: function () {
			this.$("#actFormSubmit").hide();
		},
	});

	var ActContentView = Backbone.View.extend({	
		initialize: function(options) {
			this.hideAll();
			
			this.actModel = options.actModel;
			this.event = options.event;
			this.submittedData = options.submittedData;
			
			_.bindAll(this, 'successCallback');
			_.bindAll(this, 'errorCallback');
			_.bindAll(this, 'formEnter');
			
			$('#actBodyContentForm').on("keyup", this.formEnter);
			
			this.listenTo(this.event, 'save', this.submitForm);
			this.listenTo(this.event, 'default', this.form);
			this.listenTo(this.event, 'saving', this.processing);
			this.listenTo(this.event, 'errorPrevAct', this.alreadyActivated);
			this.listenTo(this.event, 'error', this.form);
			this.listenTo(this.event, 'success', this.success);
		},
		
		submitForm: function () {
			if(!this.submittedData.isSubmitted){
				this.event.trigger("saving");
				
				//Attempt to activate key
				var key = this.$("#actKeyInput").val();
				
				if(key && key.length > 0){
					this.submittedData.isSubmitted = true;
					
					this.actModel.set("key", key, {silent: true});
					this.actModel.set("activationType", "ACTIVATION", {silent: true});
					
					this.actModel.save({
						key: key,
						activationType : "ACTIVATION"
					},{wait: true,
						success : this.successCallback, 
						error : this.errorCallback
					});
				} else {
					this.event.trigger("error");
				}	
			}
		},
		
		successCallback: function(model, response) {
			this.event.trigger("savingSuccess", model, response);
		},
		
		errorCallback: function(model, error) {
			this.event.trigger("savingError", model, error);
		},
		
		formEnter: function(e) {
			var code = e.keyCode || e.which; 
			if (code  == 13) {               
				e.preventDefault();
				this.event.trigger("save");
				return false;
			}
		},
		
		hideAll: function() {
			$(this.el).hide();
			
			this.$("#actBodyContentForm").hide();
			this.$("#actBodyContentProcessing").hide();
			this.$("#actBodyContentAlreadyActivated").hide();
			this.$("#actBodyContentSuccess").hide();
			
			//Hide error messages
			this.$("#actKeyGrp").removeClass("error");
			this.$("#actKeyInput").removeClass("error");
			this.$("#actKeyErrMsg").hide();
		},
		
		success: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#actBodyContentSuccess").show();
		},
		
		alreadyActivated: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#actBodyContentAlreadyActivated").show();
		},
		
		processing: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#actBodyContentProcessing").show();
		},
		
		form: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#actBodyContentForm").show();
		},
	});

	var ActMessageView = Backbone.View.extend({
		initialize: function(options) {
			this.hideAll();
			
			this.event = options.event;
			
			this.listenTo(this.event, 'default', this.hideAll);
			this.listenTo(this.event, 'saving', this.processing);
			this.listenTo(this.event, 'errorPrevAct', this.hideAll);
			this.listenTo(this.event, 'error', this.error);
			this.listenTo(this.event, 'success', this.success);
		},
		
		hideAll: function() {
			$(this.el).hide();
			
			this.$("#actBodyMessageError").hide();
			this.$("#actBodyMessageProcessing").hide();
			this.$("#actBodyMessageSuccess").hide();
		},
		
		error: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#actBodyMessageError").show();
		},
		
		success: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#actBodyMessageSuccess").show();
		},
		
		processing: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#actBodyMessageProcessing").show();
		},
	});
	
	var ActView = Backbone.View.extend({
		el: $("#actContent"),
		
		initialize: function(options) {
			this.actModel = options.actModel;
			this.event = _.extend({}, Backbone.Events);
			this.submittedData = {isSubmitted : false};
			
			this.message = new ActMessageView({el: this.$("#actBodyMessage"), event: this.event});
			this.content = new ActContentView({
				el: this.$("#actBodyContent"), 
				event: this.event, 
				actModel: this.actModel,
				submittedData: this.submittedData});
			this.footer = new ActFooterView({el: this.$("#actFooter"), event: this.event});
			
			this.listenTo(this.event, 'savingSuccess', this.actSuccess);
			this.listenTo(this.event, 'savingError', this.actError);
		},
		
		render: function () {
			this.event.trigger("default");
			return this;
		},
		
		actError: function(model, error) {
			if(this.submittedData.isSubmitted){
				if (error.status == 409) {
					//Key already activated
					this.event.trigger("errorPrevAct");
				} else if (error.status == 404) {
					//Resource doesn't exist
					this.event.trigger("error");
				} else if (error.status == 400) {
					//Invalid key
					this.event.trigger("error");
				} else {
					this.event.trigger("error");
				}
				
				this.submittedData.isSubmitted = false;
			}
		},
		
		actSuccess: function () {
			this.submittedData.isSubmitted = false;
			this.event.trigger("success");
		},
		
		processKey: function () {
			this.event.trigger("save");
		}
	});
	
	return ActView;  
});